import {
    ERROR,
} from './constants';

export function formatError(error: ERROR | null): string {
    switch (error) {
        case ERROR.IS_REQUIRED: {
            return 'Is required';
        }
        case ERROR.TOO_LARGE: {
            return 'Too large';
        }
        case ERROR.TOO_MANY: {
            return 'Too many';
        }
        case null: {
            return '';
        }
    }
}
